import { isIOSApp } from "../../../utils/common";

const FeaturedTopicsNavigate: React.FC = () => {
  return (
    <div className="featured-articles-container">
      <p>
        <a href="/" className="breadcrumb-link">
          Help Desk
        </a>{" "}
        &#10132;{" "}
        <a href="/featured-topics" className="breadcrumb-link">
          Featured Topics
        </a>{" "}
        &#10132; How do I navigate the company panel?
      </p>
      <h2 className="help-heading">How do I navigate the company panel?</h2>
      <p className="featured-article-text">
        On wider screens your screen will be split into the left side panel for
        the company metrics and the right side for the conversation channel:
      </p>
      <img
        src={require("../../../assets/nav-article-1.png")}
        alt="nav-article-1"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        If you are on a desktop or laptop and don't see a split screen as shown
        above, check to see if your browser magnification or text size is set
        above 100%.
      </p>
      <p className="featured-article-text">
        On the left side or Company panel you will find the last price, stock
        chart and basic information such as market cap, float (number of shares
        outstanding), trading volume, etc.
      </p>
      <p className="featured-article-text">
        Clicking anywhere on the company title bar including the circle on the
        right with a + inside it will expand the company panel while hiding the
        conversation channel. Clicking again anywhere on the company title bar
        or the circle on the far right with the{" "}
        <span style={{ fontWeight: "bolder" }}>X</span> will shrink the company
        panel and restore the chat panel.
      </p>
      <img
        src={require("../../../assets/nav-article-2.png")}
        alt="nav-article-2"
        className="basic-article-1"
      />
      <h4>Historical Chart Data</h4>
      <p className="featured-article-text">
        In addition to selecting your preferred timeframe with the buttons below
        the chart, by hovering or dragging the mouse across the chart, you can
        display price metrics from past trading sessions. In the following
        example, the open, close, high, low and volume are shown for July 16,
        2020: tap or click on the company to go to that channel.
      </p>
      <img
        src={require("../../../assets/nav-article-3.png")}
        alt="nav-article-3"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        If you then click or tap on that date and then move over to the
        discussion channel/chat window you will find it will have synchronized
        with the date you have selected. In other words, if you want to see the
        discussion on a particular day, click/tap that day on the chart and the
        discussion channel will zoom to that day.
      </p>
      <h4>Company Metrics</h4>
      <p className="featured-article-text">
        Below the chart you will find some basic company metrics:
      </p>
      <img
        src={require("../../../assets/nav-article-4.png")}
        alt="nav-article-4"
        className="basic-article-1"
      />
      <ul>
        <li>
          Market Capitalization - the value of the company when the number of
          shares is multiplied by the current price
        </li>
        <li>
          Shares - the number of outstanding shares of the company (undiluted -
          this number does not include outstanding options, warrants, etc.)
        </li>
        <li>
          Shorts - number of shares that have been sold short (i.e. sell and
          wait to buy back at a lower price. Shares may be borrowed or in the
          case of naked shorting, simply sold with an obligation to buy in the
          future to close the trade)
        </li>
        <li>Bid - the highest price a buyer is willing to pay</li>
        <li>Ask - the lowest price a seller is willing to sell</li>
        <li>
          Total Volume - the number of shares traded across all exchanges in the
          last session or if intraday, up to that point in the session on a
          15-minute delay{" "}
        </li>
        <li>
          CSE/TSX/TSXV Volume - the volume traded on the exchange the stock is
          listed on (its native exchange)
        </li>
        <li>
          ATS Vol - the volume traded on the Alternative Trading System -
          Sometimes orders are split between the native exchange (the exchange
          the stock is listed on) and other exchanges, so only a part of one's
          order will show on the native exchange. Sometimes the volume won't
          show up at all on the native exchange as it all goes through ATS
        </li>
        <li>Average Vol - the average daily trading volume</li>
      </ul>
      <h4>Company Research (aka Due Dillegence or DD for Short)</h4>
      <p className="featured-article-text">
        Beneath the chart and current metrics, you will find buttons for further
        research which may include
      </p>
      <img
        src={require("../../../assets/nav-article-5.png")}
        alt="nav-article-5"
        className="basic-article-1"
      />
      <ul>
        <li>
          SEDI (System for Electronic Disclosure by Insiders) filings which
          detail share related transactions made by insiders. This can include
          buying and selling common shares, grants of options, addition of
          warrants, exercising of warrants, expiration of warrants, RSUs
          (Restricted Share Units) and private transactions
        </li>
        <li>
          SEDAR (System for Electronic Document Analysis and Retrieval)
          documents which include material news releases and financial filings
          (i.e. quarterly and annual financial reports)
        </li>
        <li>Company website link</li>
        <li>
          Community Wiki. The Community Wiki is crowd-sourced due diligence. Not
          all companies have one or maybe up to date, as their creation and
          maintenance are dependent on the CEO.ca community.
        </li>
        <li>Some corporate channels also include:</li>
        <li>
          Financings: a link to the TMX website listing details of past
          financings
        </li>
        <li>
          Short History: A summary of the recent short positions and changes in
          short positions. Example:
        </li>
      </ul>
      <img
        src={require("../../../assets/nav-article-6.png")}
        alt="nav-article-6"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        The value in the <span style={{ fontWeight: "bold" }}>Shares</span>{" "}
        column is the shares reported short on that day. The{" "}
        <span style={{ fontWeight: "bold" }}>Net Change</span> column reports
        the change in shares shorted from the previous reporting period.{" "}
      </p>
      <p className="featured-article-text">
        A negative net change would indicate a more bullish sentiment while a
        positive net change would indicate a bearish sentiment.
      </p>
      <h4>Order Book / Market Depth {!isIOSApp ? '(PRO Subscription Only)' : ''}</h4>
      <p className="featured-article-text">
        Before we get started on this topic, please note that if you see a
        market depth chart that looks like this:
      </p>
      <img
        src={require("../../../assets/nav-article-7.png")}
        alt="nav-article-7"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        in which there are green bars (bids) on the same line as red bars
        (shares offered for sale),{" "}
        <span style={{ textDecorationLine: "underline" }}>it is a glitch</span>{" "}
        and should be rectified soon.
      </p>
      <p className="featured-article-text">
        Market depth is of interest to indicate how motivated buyers and sellers
        are. If Asks are thin there are few sellers at this price point. If Asks
        are heavy, people are looking to exit, but want a little more than the
        market is currently offering.
      </p>
      <p className="featured-article-text">
        If Bids are heavy, interest is present, but buyers are willing to wait
        for the sellers to sell into the bid. They are offering support to the
        price, not by buying, but by preventing the price from falling very far.
      </p>
      <p className="featured-article-text">
        CSE (Canadian Securities Exchange) listed stocks (not TSX or TSXV except
        by subscription) will include a bar graph with Level 2 data. Level 2
        data is the order book for that stock, also known as market depth. The
        order book indicates all open bids and offers or in other words, how
        many shares and at what price buyers are willing to pay and how many
        shares and at what price sellers are willing to sell at.{" "}
      </p>
      <p className="featured-article-text">
        The buy orders are green, sell orders are in red. While markets are
        open, the order book can change with every tick on high volume stocks.
        On low volume stocks, you may see the same orders sit there for
        days/weeks/months.
      </p>
      <p className="featured-article-text">
        Upon mouseover or tap, the bars in the CEO.ca graphical order book will
        indicate which trading house has placed the order, the date the order
        was placed and the volume or size of the order. Note that this display
        is on a 15-minute delay.
      </p>
      <p className="featured-article-text">
        In this example, BMO has placed a buy order on May 4 @ 10:04 for 20,000
        shares at $0.56.
      </p>
      <img
        src={require("../../../assets/nav-article-8.png")}
        alt="nav-article-8"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        Should you place a buy order at $0.56 you would be placed in the queue
        and be second in line as the general rule is FIFO (first in, first out).
      </p>
      <p className="featured-article-text">
        This does not mean your trade will be filled only after the BMO order
        though, as trading houses typically fill orders within their own house
        first. You could place a buy order at the end of a very long line and
        get filled before anyone else if a large seller from the same trading
        house as you sold at market and there was no one from your trading house
        ahead of you or there were enough shares in the sell order to fill all
        those ahead you and you as well. Sometimes it pays to be with a large
        trading house, sometimes it is the opposite.
      </p>
      <p className="featured-article-text">
        Moving your mouse to the grey area to the left of any bar or tapping on
        that same area will indicate the total number of trading houses, shares
        and dollar value at a given price level. Below you will see the figures
        for the $0.50 bid level:
      </p>
      <img
        src={require("../../../assets/nav-article-9.png")}
        alt="nav-article-9"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        The numbers rising up the left side of the chart are the volume of the
        trades throughout the day from AM to PM going from left to right. On the
        chart above, we can see the largest trades were completed early in the
        morning and late in the day.
      </p>
      <p className="featured-article-text">
        To see the same information sourced from the ATS (Alternative Trading
        System), click or tap the ATS button below the chart. To return to the
        CSE data, click or tap on the CSE button.
      </p>
      <p className="featured-article-text">
        As shown below, one can shift the chart up or down to see higher Asks or
        lower Bids than the chart currently shows by clicking or tapping on the{" "}
        <span style={{ fontWeight: "bold" }}>Up</span> arrow to see higher Asks
        or the <span style={{ fontWeight: "bold" }}>Down</span> arrow to see
        lower Bids. Clicking or tapping on the circle between the arrows will
        return the chart to its original position.
      </p>
      <img
        src={require("../../../assets/nav-article-10.png")}
        alt="nav-article-10"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        Real-time order depth on stocks listed on other exchanges (i.e. TSX and
        TSXV) is available by CEO.ca subscription (15-minute delay on ATS).{" "}
      </p>
      <p className="featured-article-text">
        Below the market depth chart are three drop-down tables, two of which
        summarize the in-depth chart and one which lists recent trades. Click or
        tap anywhere on the title of the item you wish to expand and click on
        the title once again to collapse it.
      </p>
      <img
        src={require("../../../assets/nav-article-11.png")}
        alt="nav-article-11"
        className="basic-article-1"
      />
      <h4>Market by Price</h4>
      <img
        src={require("../../../assets/nav-article-12.png")}
        alt="nav-article-12"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        Market by Price is the same information as is displayed in the market
        depth bar chart displayed in a table so one can see the actual numbers
        without mousing over each bar in the depth chart.
      </p>
      <p className="featured-article-text">
        It is a list of the total volume or number of shares for sale and their
        corresponding dollar value at each of up to 10 price points and the
        total volume and dollar value of the number of shares buyers are willing
        to buy at each of up to 10 price points.
      </p>
      <p className="featured-article-text">
        Sometimes there are not 10 price points on the Ask side as there are not
        enough shares offered for sale to fill 10 different price points.
      </p>
      <p className="featured-article-text">
        Some lower-priced stocks don't have the full 10 Bid price points listed
        as there are not any bids at a particular price point, or the price is
        too low to allow all 10 to be displayed.
      </p>
      <h4>Market by Order</h4>
      <img
        src={require("../../../assets/nav-article-13.png")}
        alt="nav-article-13"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        Market by Order is a similar chart to Market by Price, but it groups the
        orders at each price by trading house and rather than dollar amounts, it
        gives the total volume or number of shares that each house is bidding
        for or offering for sale and the furthest back date that an order from
        that house at that price was placed.
      </p>
      <h4>Recent Trades</h4>
      <img
        src={require("../../../assets/nav-article-14.png")}
        alt="nav-article-14"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        Recent trades are a listing of each individual trade, also called a Time
        & Sales chart. This will tell you how long ago the last trade was and
        how many trades are being completed that day. If there are many trades,
        the <span style={{ fontWeight: "bold" }}>older</span> text above the
        chart will be darker and allow paging to previous trades that day. Click
        or tap on <span style={{ fontWeight: "bold" }}>reset</span> to go back
        to the present.
      </p>
      <p className="featured-article-text">
        During the trading day, the time of each trade is indicated, at some
        point after close of the markets it reverts to simply the date.
      </p>
      <p className="featured-article-text">
        At the bottom of the Company Panel are the News Releases:
      </p>
      <img
        src={require("../../../assets/nav-article-15.png")}
        alt="nav-article-15"
        className="basic-article-1"
      />
      <p className="featured-article-text">
        Clicking or tapping on the{" "}
        <span style={{ fontWeight: "bold" }}>show more</span> will load the next
        few news releases. Tap or click on the news release to load the news
        release into the chat window/panel.
      </p>
    </div>
  );
};

export default FeaturedTopicsNavigate;
